import React from "react";
import EditButton from "../buttons/EditButton";
import TimeSpentCard from "./TimeSpentCard";
import {getDifferenceBetweenTwoNumber, getPercent, getReversePercent} from "../../utils/utils";
import {useSelector} from "react-redux";
import styled from "styled-components";
import {
    BudgetAndTimeContainer,
    NameSectionBudgetAndTime as NameSection,
    WrapperBudgetAndTime
} from "../styles/styles";

const TimesSpent = ({
                        setOpenEditModal,
                        openEditTimeSpentModal
                    }) => {

    const {realTimeSpent, estimatedTimeSpent, isTimeSpentOptional} = useSelector(state => state.project)
    return (
        <Container>
            <NameSection>
                <h2> Temps passés </h2>
                {!openEditTimeSpentModal &&
                <EditButton
                    setUpdate={setOpenEditModal}
                    data={openEditTimeSpentModal}
                />
                }
            </NameSection>
            {isTimeSpentOptional ?
                <p> L'estimation de temps n'est pas activée pour ce projet </p>
                :
                <Wrapper>
                    <LeftContainer>
                        <TimeSpentCard
                            name={"real"}
                            title={"Réel"}
                            total={realTimeSpent}
                            percent = {getPercent(estimatedTimeSpent,realTimeSpent)}
                        />
                        <TimeSpentCard
                            name={"estimated"}
                            title={"Prévisionnel"}
                            total={estimatedTimeSpent}
                        />
                    </LeftContainer>
                    <TimeSpentCard
                        name={"balance"}
                        title={"Balance"}
                        total={getDifferenceBetweenTwoNumber(estimatedTimeSpent, realTimeSpent)}
                        percent = {getReversePercent(estimatedTimeSpent,realTimeSpent)}
                    />
                </Wrapper>
            }
        </Container>
    )
}

const Container = styled(BudgetAndTimeContainer)`
  height: 100%;
  padding: 1rem;
  align-items:center;
`

const Wrapper = styled(WrapperBudgetAndTime)`
  flex-direction: column;
  //background: #3394F6;

  .balance-time {
    width: 100%;
    border-radius: 15px;
    height: 70px;
    background: linear-gradient(to bottom, rgba(73, 9, 170, 0.15) 0%, rgba(255, 255, 255, 0.75) 100%), radial-gradient(at top center, rgba(73, 9, 170, 0.40) 0%, rgba(255, 255, 255, 0.40) 120%) rgba(73, 9, 170, 1);
    background-blend-mode: multiply, multiply;
    padding: 0.5rem;
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.25);

    h4, h3 {
      color: #fafafa;
    }

    h3 {
      margin-top: 0.5em;
      font-size: 0.9em;
      width: 90%;
    }

    h4 {
      font-weight: 300;
      font-size: 0.8em;
    }

    p {
      font-size: 0.6em;
      font-style: italic;
      color: white;
      padding-top: 0.5rem;
    }
  }
`

const LeftContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row-reverse;
  gap: 0.5em;
  width: 100%;

  .time-estimated, .time-real {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    border-radius: 15px;
    width: 90%;
    height: 70px;
    padding-left: 1em;
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.25);

    h4, h3 {
      color: white;
    }

    h3 {
      font-size: 0.9em;
    }

    h4 {
      font-weight: 300;
      font-size: 0.8em;
    }

  }

  .time-estimated {
    background-color: rgba(255, 180, 0, 1);
  }

  .time-real {
    background-color: rgba(51, 148, 246, 1);
  }
`
export default TimesSpent;